import { Panel } from "primereact/panel";
import * as generic from "../../../../../components/Generico";
import { Divider } from "primereact/divider";
import { ReferenciaBancaria } from "../../../../../components/trust/ReferenciaBancaria";
import { ReferenciaComercial } from "../../../../../components/trust/ReferenciaComercial";
import { InfoFinancieraClientePj } from "../../../../../models/trust/clientepj/InfoFinancieraClientePj";
import { ClientePjService } from "../../../../../service/trust/ClientePjService";
import { InputComponent } from "../../../../../components/InputComponent";
import { useEffect, useState } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { useForm } from "react-hook-form";
import { BottomActionBar } from "../../../../../components/ui/BottomActionBar";

export const InfoFinancieraReferencia = ({ toast, id, permss, soloLectura, handlePrev, handleNext, nuevoCliente }) => {

    const omodel = new InfoFinancieraClientePj();
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, watch, setValue } = useForm({ defaultValues, shouldTrim: true });
    const clientePjServicio = new ClientePjService();
    const { inNumber } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    // Estados
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    // Observamos los valores
    const corriente = watch('corriente') || 0;
    const fijo = watch('fijo') || 0;
    const otrosActivos = watch('otros_activos') || 0;
    const cortoPlazo = watch('corto_plazo') || 0;
    const largoPlazo = watch('largo_plazo') || 0;

    // Efecto para realizar los cálculos automáticos
    useEffect(() => {
        const totalActivos = corriente + fijo + otrosActivos;
        const totalPasivos = cortoPlazo + largoPlazo;
        const patrimonio = totalActivos - totalPasivos;
        // Actualizamos los campos calculados
        setValue('total_activo', totalActivos);
        setValue('total_pasivos', totalPasivos);
        setValue('patrimonio', patrimonio);
    }, [corriente, fijo, otrosActivos, cortoPlazo, largoPlazo, setValue]);

    useEffect(() => {
        if (id) {
            editFicha();
        } else {
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [id]);

    const onSubmit = (data) => {
        setIsSaving(true);
        data.seccion = 'seccion3';
        data.id = id;

        clientePjServicio.editarCliente(data).then(res => {
            nuevoCliente(res.data);
            generic.funcSuccess(res, toast);
            handleNext();
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const editFicha = () => {
        setIsLoading(true);
        clientePjServicio.consultarCliente(id, { seccion: 'seccion3' }).then(res => {
            const _cli = res.data.cliente;
            if (!_cli) {
                reset(defaultValues);
                setIsLoading(false);
                return;
            }
            reset(generic.renewValues(_cli, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <div className="p-fluid">
            {/* Se reusa la misma lógica de Proveedor para Info Financiera (Corriente, fijo, etc) */}
            <Panel header={generic.renderPanelHeader('F', 'INFORMACIÓN FINANCIERA DE LA COMPAÑÍA (ÚLTIMO AÑO)', 'pi pi-chart-line')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                <form id="infoFinancieraForm" onSubmit={handleSubmit(onSubmit, onError)}>
                    <div className="grid formgrid">
                        <div className="col-12 md:col-6 mb-2 md:mb-0">
                            <div className="p-3 surface-50 border-round h-full flex flex-column shadow-1">
                                <div>
                                    <div className="text-center text-primary font-bold mb-3 border-bottom-1 pb-2 text-lg">ACTIVOS</div>
                                    {inNumber('corriente', 2, true, { icon: 'pi pi-money-bill', iconPosition: 'left' }, 12)}
                                    {inNumber('fijo', 2, true, { icon: 'pi pi-building', iconPosition: 'left' }, 12)}
                                    {inNumber('otros_activos', 2, true, { icon: 'pi pi-box', iconPosition: 'left' }, 12)}
                                </div>
                                <div className="mt-auto">
                                    <Divider type="dashed" className="my-2" />
                                    <div className="bg-blue-50 p-2 border-round border-1 border-blue-200">
                                        {inNumber('total_activo', 2, true, { icon: 'pi pi-chart-bar', iconPosition: 'left', disabled: true }, 12)}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 md:col-6">
                            <div className="p-3 surface-50 border-round h-full flex flex-column shadow-1">
                                <div>
                                    <div className="text-center text-primary font-bold mb-3 border-bottom-1 pb-2 text-lg">PASIVOS</div>
                                    {inNumber('corto_plazo', 2, true, { icon: 'pi pi-calendar-minus', iconPosition: 'left' }, 12)}
                                    {inNumber('largo_plazo', 2, true, { icon: 'pi pi-calendar-plus', iconPosition: 'left' }, 12)}
                                </div>
                                <div className="mt-auto">
                                    <Divider type="dashed" className="my-2" />
                                    <div className="bg-blue-50 p-2 border-round border-1 border-blue-200">
                                        {inNumber('total_pasivos', 2, true, { icon: 'pi pi-chart-bar', iconPosition: 'left', disabled: true }, 12)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="grid mt-2">
                        <div className="col-12 md:col-4 md:col-offset-4">
                            <div className="bg-blue-100 p-2 border-round border-1 border-blue-300 shadow-2">
                                {inNumber('patrimonio', 2, true, { icon: 'pi pi-wallet', iconPosition: 'left', disabled: true }, 12)}
                            </div>
                        </div>
                    </div>

                    <Divider align="center" className="mt-4 mb-3">
                        <span className="p-tag p-tag-rounded p-tag-secondary">Estado de Resultados</span>
                    </Divider>
                    <div className="grid formgrid">
                        <div className="col-12 md:col-6">
                            {inNumber('total_ingresos', 2, true, { icon: 'pi pi-arrow-up-right', iconPosition: 'left' }, 12)}
                        </div>
                        <div className="col-12 md:col-6">
                            {inNumber('total_egresos', 2, true, { icon: 'pi pi-arrow-down-right', iconPosition: 'left' }, 12)}
                        </div>
                    </div>
                </form>
            </Panel>

            <Panel header={generic.renderPanelHeader('G', 'REFERENCIAS BANCARIAS', 'pi pi-address-book')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                <div className="p-2 mb-4">
                    <ReferenciaBancaria id={id} tipo="clientePj" toast={toast} permss={permss} soloLectura={soloLectura} />
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('H', 'REFERENCIAS COMERCIALES', 'pi pi-address-book')} style={{ width: '100%', margin: 'auto' }} className="panel-ficha shadow-1 mb-4">
                <div className="p-2 border-top-1 border-300 pt-4">
                    <ReferenciaComercial id={id} tipo="clientePj" toast={toast} permss={permss} soloLectura={soloLectura} />
                </div>
            </Panel>

            <BottomActionBar layoutVersion="v2" formId="infoFinancieraForm" onPrev={handlePrev} onNext={handleNext} loading={isSaving} isReadOnly={soloLectura} />
        </div>
    );
}